import styled, { createGlobalStyle } from 'styled-components';
import { Grid } from '@mui/material';
import { colorTheme } from '@styles/muiTheme';

export const StyleOverride = createGlobalStyle`
.customer-details.MuiTypography-h1 {
    font-size: 30px;
    margin: 40px 0 0px 20px;
 }
.customer-info {
  margin-top: 20px;
  margin-bottom: -35px;
  
  .MuiTypography-h3 {
    font-size: 21px;
  }
}
.dealsheet-history, .payoff {
  position: relative;

  .MuiDataGrid-footerContainer {
    display: none;
  }

  .MuiDataGrid-columnHeader {
    display: none;
  }

  .MuiDataGrid-columnHeaders {
    display: none;
  }

  .MuiTypography-h3 {
    position: absolute;
    top: 34px;
  }
}

.payoff .MuiTypography-h2 {
  position: absolute;
  top: 34px;
  font-size: 21px;
}

.adjustments {
  position: relative;
} 
.adjustments .MuiTypography-h2 {
  font-size: 21px;
}

.dealsheet-history .MuiTypography-h2 {
  position: absolute;
  top: 20px;
  font-size: 21px;
}

.deal-sheet-forms .MuiInputBase-root {
  margin-top: -3px;
}

.deal-sheet-forms .MuiTypography-h2{
  font-size: 21px;
}

.deal-summary {
  position: relative;
  top: -4px;
}

.product-info, .revenue-detail {
  .MuiDataGrid-virtualScrollerRenderZone {
    background: ${colorTheme.palette.common.white};
  }

  .MuiInputBase-input {
    margin-top:2px;
    height:1em;
  }

  .MuiDataGrid-editInputCell {
    margin-top: 2px;
  }

  .MuiDataGrid-footerContainer {
    display: none;
  }
}
`;

export const HeaderWrapper = styled.section`
  display: flex;
  justify-content: space-between;
`;

export const PageWrapper = styled.section`
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  position: relative;
`;

export const LeftPanel = styled(Grid)`
  background-color: ${colorTheme.palette.secondary.light};
  padding-left: 10px; 
  padding-right: 10px; 
`;

export const RightPanel = styled(Grid)`
  background-color: ${colorTheme.palette.grey[500]};
  padding-left: 10px; 
  padding-right: 10px; 
`;

export const ButtonsSection = styled.div<{ justifyContent?: string, bml?: string, mb?: string, mr?: string, mt?: string, ml?: string, }>`
  color: ${colorTheme.palette.primary.main};
  margin-left: ${({ ml }) => ml};
  margin-right: ${({ mr }) => mr};
  margin-top: ${({ mt }) => mt};
  margin-bottom: ${({ mb }) => mb};
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-end'};

  button {
    margin-left: ${({ bml }) => bml};
  }
`;

export const DealSheetSummaryDiv = styled.div`
  margin-bottom: 20px;
`;

export const DealSheetHeader = styled.div`
  padding: 10px 0px;

  .MuiTypography-root {
    color: ${({ theme }) => theme.palette.common.black};
  }

  h6.MuiTypography-root {
    color: ${({ theme }) => theme.palette.info.dark};
    font-weight: 800;
    cursor: pointer;
    justifyContent: end
  }
`;

